"use strict";


export function toHump(str) {
  return str.replace(/\_(\w)/g, function (all, letter) {
    return letter.toUpperCase();
  });
}

export function toLineThrough(str) {
  return str.replace(/([A-Z])/g, "-$1").toLowerCase();
}

export function toUnderLine(str) {
  return str.replace(/([A-Z])/g, "_$1").toLowerCase();
}


export function ellipsis(value, maxLength, tail, smartFlag) {
  const Tail = tail || '...';
  const SmartFlag = smartFlag || true;
  if (!value) {
    return '';
  }
  maxLength = parseInt(maxLength, 10);
  if (!maxLength) {
    return value;
  }
  if (SmartFlag) {
    maxLength = maxLength * 2;
  }
  let limitStr = getLimitStr(value, maxLength);
  return limitStr + (value === limitStr ? '' : Tail);

  function getLimitStr(value, maxLength) {
    value += "";
    let resultArr = [];
    let strArr = value.split("");
    let len = 0;

    for (let i = 0; i < strArr.length; i++) {
      let c = value.charCodeAt(i);
      if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
        len++;
      }
      else {
        len += 2;
      }
      if (len > maxLength) {
        break;
      }
      resultArr.push(strArr[i]);
    }
    return resultArr.join("");
  }
}

export function getTimeByTimeStr(dateString) {
  if(!dateString){
    return null;
  }
  dateString = dateString.substring(0,19);
  dateString = dateString.replace(/-/g,'/');
  return new Date(dateString);
}

export function formatTime(date, format) {
  if(date!=null){
    var o = {
      "M+" : date.getMonth()+1, //month
      "d+" : date.getDate(), //day
      "h+" : date.getHours(), //hour
      "m+" : date.getMinutes(), //minute
      "s+" : date.getSeconds(), //second
      "q+" : Math.floor((date.getMonth()+3)/3), //quarter
      "S" :  date.getMilliseconds() //millisecond
    };
    if(/(y+)/i.test(format)) {
      format = format.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length));
    }
    for(let k in o) {
      if(new RegExp("("+ k +")").test(format)) {
        format = format.replace(RegExp.$1, RegExp.$1.length==1 ? o[k] : ("00"+ o[k]).substr((""+ o[k]).length));
      }
    }
    return format;
  }else{
    return "---";
  }
}


export function guid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0,
      v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}




// WEBPACK FOOTER //
// ./src/common/util/string.util.js